/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdGroupDetailResponse } from './AdGroupDetailResponse';
import {
    AdGroupDetailResponseFromJSON,
    AdGroupDetailResponseFromJSONTyped,
    AdGroupDetailResponseToJSON,
    AdGroupDetailResponseToJSONTyped,
} from './AdGroupDetailResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface AdGroupDetailResponsePagedResult
 */
export interface AdGroupDetailResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof AdGroupDetailResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<AdGroupDetailResponse>}
     * @memberof AdGroupDetailResponsePagedResult
     */
    data: Array<AdGroupDetailResponse> | null;
}

/**
 * Check if a given object implements the AdGroupDetailResponsePagedResult interface.
 */
export function instanceOfAdGroupDetailResponsePagedResult(value: object): value is AdGroupDetailResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AdGroupDetailResponsePagedResultFromJSON(json: any): AdGroupDetailResponsePagedResult {
    return AdGroupDetailResponsePagedResultFromJSONTyped(json, false);
}

export function AdGroupDetailResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdGroupDetailResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(AdGroupDetailResponseFromJSON)),
    };
}

export function AdGroupDetailResponsePagedResultToJSON(json: any): AdGroupDetailResponsePagedResult {
    return AdGroupDetailResponsePagedResultToJSONTyped(json, false);
}

export function AdGroupDetailResponsePagedResultToJSONTyped(value?: AdGroupDetailResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(AdGroupDetailResponseToJSON)),
    };
}

